import React from "react";
import styles from "../Modules/Aboutme.module.css";
import { Link } from "react-scroll";
import { img1, img2, img3, img4 } from "../imports";
require("../index.css");

const journeyImages = [
  { url: img4, title: "In My Element",       description: "Building backend systems day to day"         },
  { url: img1, title: "Sharing Knowledge",   description: "Presenting and teaching to the community"    },
  { url: img2, title: "Team Collaboration",  description: "Working with inspiring teams"                },
  { url: img3, title: "Team Collaboration",  description: "Building great things with great people"    },
];

class Aboutme extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentIndex: 0,
      fading: false,
    };
    this.goTo     = this.goTo.bind(this);
    this.nextImage = this.nextImage.bind(this);
    this.prevImage = this.prevImage.bind(this);
  }

  goTo(index) {
    if (index === this.state.currentIndex || this.state.fading) return;
    this.setState({ fading: true });
    setTimeout(() => {
      this.setState({ currentIndex: index, fading: false });
    }, 280);
  }

  nextImage() {
    this.goTo((this.state.currentIndex + 1) % journeyImages.length);
  }

  prevImage() {
    this.goTo((this.state.currentIndex - 1 + journeyImages.length) % journeyImages.length);
  }

  render() {
    const { currentIndex, fading } = this.state;
    const current = journeyImages[currentIndex];
    const pad = (n) => String(n).padStart(2, "0");

    return (
      <div id="aboutme" className={styles.aboutme}>
        <div className={styles.outerContainer}>
          <div className={styles.heading}>
            <span className={styles.eyebrow}>Who I am</span>
            <h2>About Me</h2>
          </div>

          <div className={styles.container}>
            {/* ── Left: bio ── */}
            <div className={styles.contentSection}>
              <div className={styles.bio}>
                <h3>
                  My name is Soulaimane, and I am a Backend Python Engineer with
                  4 years of experience in API, SDK, and real-time system development.
                </h3>
                <div className={styles.skills}>
                  {["Python","Django","Pydantic","asyncio","PostgreSQL","Redis",
                    "WebSockets","Django Channels","Celery","React.js","Docker",
                    "Git & GitHub","CI/CD","AWS","Linux","Unit Testing"].map((t) => (
                    <span key={t} className={styles.tech}>{t}</span>
                  ))}
                </div>
                <p>
                  I am currently working at Inoser Maroc where I develop Python SDKs
                  and backend systems for a multi-agent AI platform, in collaboration
                  with a German team. I specialize in Django, asynchronous programming,
                  and complex concurrency management.
                </p>
                <p>
                  Throughout my career, I have honed my expertise in Python, utilizing
                  it to create practical and innovative solutions. I have experience
                  working with French and German clients in agile environments,
                  optimizing PostgreSQL databases and REST/WebSocket API architectures.
                  Previously, I served as a volunteer member and team lead at AIESEC.
                </p>
                <p>
                  I'm always excited to embark on new challenges and contribute to
                  projects that make a meaningful impact. Outside work, I enjoy going
                  to the gym, running, attending tech events, and spending time with family.
                </p>
                <Link className={"cta"} to={"contact"} spy smooth offset={-70} duration={1000}>
                  Get in Touch
                  <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512" className={"icon"}>
                    <path d="M201.4 342.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 274.7 86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"/>
                  </svg>
                </Link>
              </div>
            </div>

            {/* ── Right: slider ── */}
            <div className={styles.journeySection}>
              <div className={styles.slider}>
                {/* counter */}
                <div className={styles.counter}>
                  <span className={styles.counterCurrent}>{pad(currentIndex + 1)}</span>
                  <span className={styles.counterSep}>/</span>
                  <span className={styles.counterTotal}>{pad(journeyImages.length)}</span>
                </div>

                {/* image */}
                <div className={styles.imageTrack}>
                  <div className={`${styles.imageFrame} ${fading ? styles.imageFade : ""}`}>
                    <img src={current.url} alt={current.title} className={styles.journeyImage} />
                    <div className={styles.overlay}>
                      <div className={styles.overlayContent}>
                        <p className={styles.overlayTitle}>{current.title}</p>
                        <p className={styles.overlayDesc}>{current.description}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* controls row */}
                <div className={styles.controls}>
                  <div className={styles.dots}>
                    {journeyImages.map((_, i) => (
                      <button
                        key={i}
                        className={`${styles.dot} ${i === currentIndex ? styles.activeDot : ""}`}
                        onClick={() => this.goTo(i)}
                        aria-label={`Go to image ${i + 1}`}
                      />
                    ))}
                  </div>
                  <div className={styles.arrows}>
                    <button className={styles.arrowBtn} onClick={this.prevImage} aria-label="Previous">
                      ←
                    </button>
                    <button className={styles.arrowBtn} onClick={this.nextImage} aria-label="Next">
                      →
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Aboutme;
